import { usersSlice } from './usersSlice'

export const { addUser, addUsers } = usersSlice.actions
